import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import EditModal from "../ui/EditModal";

const AddAtributosPorPatologia = () => {
  const [editandoRelacion, setEditandoRelacion] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [AtributosPorPatologia, setAtributosPorPatologia] = useState([]);
  const [Patologias, setPatologias] = useState([]);
  const [IdPatologia, setIdPatologia] = useState("");
  const [Atributos, setAtributos] = useState([]);
  const [IdAtributo, setIdAtributo] = useState("");

  useEffect(() => {
    getPatologias();
    getAtributos();
  }, []);

  useEffect(() => {
    setIdAtributo("");
    getAtributosPorPatologia();
  }, [IdPatologia]);

  const getPatologias = async () => {
  try {
    const response = await api.get(`/patologias`);
    // Solo activas
    const activas = response.data.filter((p) => p.estado === 1);
    setPatologias(activas);
  } catch (error) {
    console.error("Error al obtener patologías:", error);
    Swal.fire("Error", "No se pudieron cargar las patologías", "error");
  }
};
  const getAtributos = async () => {
  try {
    const response = await api.get(`/atributos`);
    // Filtrar atributos activos usando la propiedad correcta 'Estado'
    const activos = response.data.filter((a) => a.Estado === 1);
    setAtributos(activos);
  } catch (error) {
    console.error("Error al obtener atributos:", error);
  }
};
  const getAtributosPorPatologia = async () => {
    if (!IdPatologia) return;
    try {
      const response = await api.get(`/atributosPorPatologia/${IdPatologia}`);
      setAtributosPorPatologia(response.data);
    } catch (error) {
      console.error("Error al obtener atributos por patología:", error);
    }
  };

  const createAtributoPorPatologia = async (e) => {
    e.preventDefault();

    if (!IdPatologia || !IdAtributo) {
      return Swal.fire("Campos incompletos", "Debe seleccionar una patología y un atributo.", "warning");
    }

    const yaExiste = AtributosPorPatologia.some((item) => item.IdAtributo === IdAtributo);
    if (yaExiste) {
      return Swal.fire("Duplicado", "Este atributo ya está asociado a la patología.", "error");
    }

    try {
      await api.post(`/atributosPorPatologia`, {
        IdPatologia,
        IdAtributo,
      });
      Swal.fire("Éxito", "El atributo se asoció correctamente a la patología.", "success");
      getAtributosPorPatologia();
      setIdAtributo("");
    } catch (error) {
      console.error("Error al guardar:", error);
      Swal.fire("Error", "Ocurrió un error al guardar. Intente nuevamente.", "error");
    }
  };

  const cambiarEstado = async (id) => {
    try {
      const response = await api.patch(`/atributosPorPatologia/toggle/${id}`);
      const nuevoEstado = response.data.estado === 1 ? "activado" : "desactivado";
      Swal.fire("Actualizado", `El atributo ha sido ${nuevoEstado} correctamente`, "success");
      getAtributosPorPatologia();
    } catch (error) {
      console.error("Error al cambiar estado:", error);
      Swal.fire("Error", "No se pudo cambiar el estado", "error");
    }
  };

  const handleEditar = async (valores) => {
    try {
      await api.put(`/atributos/${valores.IdAtributo}`, {
        Nombre: valores.Nombre,
        Descripcion: valores.Descripcion || "",
      });
      Swal.fire("Actualizado", "El atributo ha sido editado correctamente", "success");
      setEditandoRelacion(null);
      getAtributosPorPatologia();
      getAtributos();
    } catch (error) {
      console.error("Error al editar:", error.response?.data || error.message);
      Swal.fire("Error", "No se pudo actualizar el atributo", "error");
    }
  };

  const editFields = [
    {
      name: "Nombre",
      label: "Nombre",
      type: "text",
      required: true,
    },
    {
      name: "Descripcion",
      label: "Descripción",
      type: "textarea",
      required: false,
    },
  ];

  const filtrarPorEstado = () => {
    if (filtroEstado === "todas") return AtributosPorPatologia;
    if (filtroEstado === "activas") return AtributosPorPatologia.filter((a) => a.estado === 1);
    if (filtroEstado === "inactivas") return AtributosPorPatologia.filter((a) => a.estado === 0);
    return AtributosPorPatologia;
  };

  useEffect(() => {
    let mensaje = "";
    switch (filtroEstado) {
      case "activas":
        mensaje = "Mostrando relaciones activas.";
        break;
      case "inactivas":
        mensaje = "Mostrando relaciones inactivas.";
        break;
      case "todas":
        mensaje = "Mostrando todas las relaciones.";
        break;
      default:
        break;
    }

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "info",
      title: mensaje,
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
    });
  }, [filtroEstado]);

  const columnas = [
    {
      name: "Atributo",
      selector: (row) => row?.NombreAtributo || "No disponible",
      sortable: true,
    },
    {
      name: "Acciones",
      cell: (row) => (
        <>
          <button
            className="button is-small is-info mr-2"
            type= "button"
            title="Editar"
            onClick={() => setEditandoRelacion({
              IdAtributo: row.IdAtributo,
              Nombre: row.NombreAtributo,
              Descripcion: row.Descripcion || "",
            })}
          >
            <FontAwesomeIcon icon={faPencil} />
          </button>

          {row.estado === 1 ? (
            <FontAwesomeIcon
              icon={faSquarePlus}
              style={{ color: "#37ff00", cursor: "pointer", marginLeft: "10px" }}
              size="2xl"
              title="Activar"
              onClick={() => cambiarEstado(row.IdAtributoPorPatologia)}

             
            />
          ) : (
            <FontAwesomeIcon
              icon={faSquareMinus}
              style={{ color: "#ff0000", cursor: "pointer", marginLeft: "10px" }}
              size="2xl"
              title="Desactivar"
              onClick={() => cambiarEstado(row.IdAtributoPorPatologia)}
            />
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];

  const paginationOptionsES = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Atributos por Patología</strong>
        </div>

        <form onSubmit={createAtributoPorPatologia}>
          <div className="field">
            <label className="label required">Seleccionar Patología</label>
            <div className="select is-fullwidth">
              <select
                value={IdPatologia}
                onChange={(e) => setIdPatologia(parseInt(e.target.value))}
                required
              >
                <option value="">Seleccionar</option>
                {Patologias.map((p) => (
                  <option key={p.IdPatologia} value={p.IdPatologia}>
                    {p.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <label className="label required">Atributos</label>
            <div className="select is-fullwidth">
              <select
                value={IdAtributo}
                onChange={(e) => setIdAtributo(parseInt(e.target.value))}
                required
              >
                <option value="">Seleccionar</option>
                {Atributos.map((a) => (
                  <option key={a.IdAtributo} value={a.IdAtributo}>
                    {a.Nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field mt-3">
            <button type="submit" className="button is-success">
              Guardar
            </button>
          </div>

          <div style={{ display: "flex", gap: "10px", marginBottom: "1rem" }}>
            {["todas", "activas", "inactivas"].map((estado) => (
              <button
                key={estado}
                onClick={() => setFiltroEstado(estado)}
                type="button"
                style={{
                  padding: "6px 16px",
                  border: "none",
                  borderRadius: "20px",
                  backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
                  color: filtroEstado === estado ? "#075e54" : "#333",
                  fontWeight: filtroEstado === estado ? "bold" : "normal",
                  boxShadow: filtroEstado === estado ? "inset 0 0 0 1px #1ebea5" : "inset 0 0 0 1px #ccc",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  fontSize: "0.9rem",
                }}
              >
                {estado.charAt(0).toUpperCase() + estado.slice(1)}
              </button>
            ))}
          </div>

          <div className="mt-4">
            <DataTable
              pagination
              paginationComponentOptions={paginationOptionsES}
              columns={columnas}
              data={filtrarPorEstado()}
            />
          </div>
        </form>

        {editandoRelacion && (
          <EditModal
            fields={editFields}
            initialValues={editandoRelacion}
            onSubmit={handleEditar}
            onClose={() => setEditandoRelacion(null)}
            title="Editar Atributo por Patología"
          />
        )}
      </div>
    </div>
  );
};

export default AddAtributosPorPatologia;
